import React from 'react';
import { motion } from 'framer-motion';
import { useGame } from '../contexts/GameContext';
import JobBoard from './JobBoard';
import ClanManagement from './ClanManagement';
import Inventory from './Inventory';
const Sidebar = ({
  activeTab,
  onTabChange
}) => {
  const {
    collectedStars
  } = useGame();
  return <div className="absolute top-0 right-0 h-full w-80 bg-gray-800 bg-opacity-90 shadow-lg flex flex-col" data-id="element-145">
      <div className="flex border-b border-gray-700" data-id="element-146">
        <button className={`flex-1 py-3 ${activeTab === 'world' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'}`} onClick={() => onTabChange('world')} data-id="element-147">
          World
        </button>
        <button className={`flex-1 py-3 ${activeTab === 'inventory' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'}`} onClick={() => onTabChange('inventory')} data-id="element-148">
          Inventory
        </button>
        <button className={`flex-1 py-3 ${activeTab === 'jobs' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'}`} onClick={() => onTabChange('jobs')} data-id="element-149">
          Jobs
        </button>
        <button className={`flex-1 py-3 ${activeTab === 'clans' ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-700'}`} onClick={() => onTabChange('clans')} data-id="element-150">
          Clans
        </button>
      </div>
      <div className="p-4 text-white overflow-y-auto flex-1" data-id="element-151">
        <motion.div className="mb-4" animate={{
        scale: collectedStars.length > 0 ? [1, 1.1, 1] : 1
      }} transition={{
        duration: 0.3
      }} data-id="element-152">
          <p className="text-sm text-gray-400" data-id="element-153">Collected Stars</p>
          <motion.p className="text-2xl font-bold" key={collectedStars.length} initial={{
          scale: 1.5,
          color: '#FFD700'
        }} animate={{
          scale: 1,
          color: '#FFFFFF'
        }} transition={{
          duration: 0.5
        }} data-id="element-154">
            {collectedStars.length} / 5
          </motion.p>
        </motion.div>
        {activeTab === 'inventory' && <Inventory data-id="element-155" />}
        {activeTab === 'jobs' && <JobBoard data-id="element-156" />}
        {activeTab === 'clans' && <ClanManagement data-id="element-157" />}
        {activeTab === 'world' && <div data-id="element-158">
            <h3 className="text-lg font-bold mb-2" data-id="element-159">Controls</h3>
            <ul className="text-sm text-gray-300 space-y-1" data-id="element-160">
              <li data-id="element-161">Movement: W,A,S,D or Arrow Keys</li>
              <li data-id="element-162">Talk to NPCs: Click on them</li>
              <li data-id="element-163">Collect Stars: Click on them</li>
            </ul>
            <h3 className="text-lg font-bold mt-4 mb-2" data-id="element-164">World Zones</h3>
            <ul className="text-sm text-gray-300 space-y-2" data-id="element-165">
              <li data-id="element-166">
                <span className="inline-block w-3 h-3 rounded-full bg-[#FF5733] mr-2" data-id="element-167"></span>
                AI Zone - Chat with AI specialists
              </li>
              <li data-id="element-168">
                <span className="inline-block w-3 h-3 rounded-full bg-[#33A1FF] mr-2" data-id="element-169"></span>
                Code Review - Get help with your code
              </li>
              <li data-id="element-170">
                <span className="inline-block w-3 h-3 rounded-full bg-[#33FF57] mr-2" data-id="element-171"></span>
                Job Board - Find developer jobs
              </li>
              <li data-id="element-172">
                <span className="inline-block w-3 h-3 rounded-full bg-[#FFD700] mr-2" data-id="element-173"></span>
                Clan Hall - Join developer clans
              </li>
            </ul>
          </div>}
      </div>
    </div>;
};
export default Sidebar;